import styled from "@emotion/styled";

export const TitleWrapper = styled.div(({theme, styles}) => ({
  gridColumn: theme?.breakpoints?.isMobile ? "1/-1" : "1/11",
  marginTop: theme?.breakpoints?.isMobile ? 32 : 40,
  ...styles,
}));

export const Emodji = styled.div(({theme}) => ({
  marginInline: theme?.breakpoints?.isMobile ? "0px 5px" : "0px 5px",
  fontFamily: theme?.font?.manrope,
  fontWeight: 400,
  fontSize: "1.125rem ",
  lineHeight: "1.625rem ",
  textAlign: "left",
  letterSpacing: "0.2em",
  color: "#C0C0C0",
}));

export const Wrapper = styled.div(() => ({
  gridColumn: "1/-1",
}));

export const InnerWrapper = styled.div(({theme}) => ({
  display: "flex",
  flexDirection: theme?.breakpoints?.isMobile ? "column" : "row",
  rowGap: 38,
  columnGap: 64,
}));

export const CTAWrapper = styled.div(() => ({
  display: "flex",
  cursor: "pointer",
}));

export const FilterWrapper = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
}));
